import { PartnerUsersList } from '@anytag/shared-organisms';
import { usePartnerDetailsContext } from './partner-details-context';

export const PartnerUsers = () => {
  const { partner } = usePartnerDetailsContext();

  return <PartnerUsersList partnerId={partner.id} />;
};
